/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_CenterInputs */



/**
* | output |
* | --- |
* | "Position Center" |
*
* @param {Shortcut_Keys_Name_Cc_Position_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_center = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner au centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionszentrum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione Centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр позиционирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro de posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置中心")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro de posição")
	return /** @type {LocalizedString} */ ("Position Center")
});